import Resource from 'components/global/Resource'
import SectionTitle from 'components/global/SectionTitle'
import { Section, Row, Col } from 'components/grid'
import { CoreAdoptionContext } from 'context/CoreAdoption'
import React, { useContext } from 'react'
import { formatSectionId } from 'components/core-adoption/functions/formatSectionId'

export default function FormativeAssessmentSpanish({ ...props }) {
	const { account, standard } = useContext(CoreAdoptionContext)
	return (
		<Section margin="mt-20" id={formatSectionId(props)} className="scroll-mt-14">
			<SectionTitle
				title="Evaluación formativa e instrucción grupal estratégica"
				text={[
					<span key={Math.random()}>
						The Evaluación del nivel independiente de lectura<sup>®</sup> (ENIL<sup>®</sup>) is a developmental reading taxonomy for students, paralleling the
						Independent Reading Level Assessment (IRLA) while reflecting how the stages of learning to read differ between Spanish and English.
					</span>
				]}
			/>
			<Row className="mx-auto mb-10 max-w-3xl justify-center">
				<Col width="w-full">
					<Row className="items-center justify-center">
						{!account?.formative_assessment.includes('ENIL | CCSS') && (
							<Col width="w-full md:w-1/2" className="my-5">
								<Resource logResourceView={{ type: 'document' }} protected title="ENIL | CCSS" />
							</Col>
						)}
						{!account?.formative_assessment.includes('ENIL | TEKS') && standard === 'teks' && (
							<Col width="w-full md:w-1/2" className="my-5">
								<Resource logResourceView={{ type: 'document' }} protected title="ENIL | TEKS" />
							</Col>
						)}
						<Col className="mt-14">
							<p className="text-center">The ENIL offers instructional support tailored to students' needs, including foundational skills lessons.</p>
						</Col>
					</Row>
				</Col>
			</Row>
		</Section>
	)
}
